export const state = {
  theme_appearance: 'light',
  mode: process.env.VUE_APP_ENV || 'development',
  vehicleType: false,
  dmsCheck: false,
  importDevice: false,
  selectableVehicleType: false,
  hideAddDomainButton: false,
  syncToERP: false,
  logHistory: false,
}

export const mutations = {
  setAppearance(state, payload) {
    state.theme_appearance = payload
  },
  setFeatureFlags(state, flags) {
    for (const [flag, value] of Object.entries(flags)) {
      state[flag] = value
    }
  },
}
